module.exports = __webpack_public_path__ + "static/media/zoomOut-dark.b58badea.svg";